"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUnselectedProductDetail = exports.hasLanguageSelectName = void 0;
/**
 * 言語選択が存在するかどうかを判定
 * @param { CartFormNameList } formNameList カートフォームの名前リスト
 * @returns { boolean } 言語選択が存在するか
 */
var hasLanguageSelectName = function (formNameList) {
    return 'languageSelectName' in formNameList;
};
exports.hasLanguageSelectName = hasLanguageSelectName;
/**
 * 選択されていない状態の商品詳細情報かどうかを判定
 * @param productDetail 商品詳細情報
 * @returns { boolean } 選択されていない状態かどうかを判定
 */
var isUnselectedProductDetail = function (productDetail) {
    return !productDetail.product_class_id;
};
exports.isUnselectedProductDetail = isUnselectedProductDetail;
